import { ComponentProps } from 'react';
import { Permissions } from '../../../../accessControl/permissions';
import { DISCIPLINES } from '../../../../utils/new_discipline';
// import env from '../../../../env';

export interface IMenuItem {
  id?: string;
  label: string;
  permission?: Permissions;
  icon: React.ComponentType<ComponentProps<'svg'>> | string;
  iconType: 'material' | 'svg';
  items: ISubMenuItem[];
  href?: string;
  old: boolean;
  clickable: boolean;
}

export interface ISubMenuItem {
  id?: string;
  permission: Permissions;
  label: string;
  icon: React.ComponentType<ComponentProps<'svg'>> | string;
  iconType: 'material' | 'svg';
  iconSize?: 'regular' | 'large';
  link: string;
  old?: boolean;
  isNew?: boolean;
  input?: boolean;
  externalLink?: boolean;
  disabled?: boolean;
}

// const PLATFORM_URL = env.REACT_APP_PLATFORM_URL;

const disciplines: ISubMenuItem[] = DISCIPLINES.sort((a, b) => a.order - b.order).map((discipline) => ({
  permission: discipline.permission,
  label: discipline.name,
  icon: discipline.icon,
  iconType: 'svg',
  link: `/disciplinas/${discipline.slug}`,
  old: false,
  isNew: false,
  disabled: discipline.disabled,
}));

export const menuItems: IMenuItem[] = [
  {
    label: 'Minha Área',
    permission: Permissions.MINHA_AREA,
    icon: 'home',
    iconType: 'material',
    href: '/',
    old: false,
    clickable: true,
    items: [],
  },
  {
    label: 'Disciplinas',
    icon: 'neurology',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/disciplinas',
    items: disciplines,
  },
  {
    label: 'Favoritos',
    icon: 'star',
    iconType: 'material',
    old: false,
    clickable: true,
    href: '/favoritos',
    items: [],
    permission: Permissions.FAVORITOS,
  },
];

export interface ISideMenuItem {
  icon: string;
  iconType: 'material' | 'svg';
  clickable: boolean;
  items: ISideMenuSubItem[];
  permission?: Permissions;
}

export interface ISideMenuSubItem {
  label: string;
  icon: string | React.ComponentType<ComponentProps<'svg'>>;
  iconType: 'material' | 'svg';
  iconSize?: 'regular' | 'large';
  link: string;
  old?: boolean;
  input?: boolean;
  externalLink?: boolean;
  permission?: Permissions;
}

export const sideMenuItems: ISideMenuItem[] = [
  {
    icon: 'menu',
    iconType: 'material',
    clickable: false,
    items: [
      {
        label: 'Perfil',
        icon: 'person',
        iconType: 'material',
        link: '/perfil',
      },
      {
        label: 'Fale conosco',
        icon: 'contact_support',
        iconType: 'material',
        link: 'https://aprovatotal.zendesk.com/hc/pt-br/requests/new',
        externalLink: true,
        permission: Permissions.ALUNO_APROVA_TOTAL,
      },
      {
        label: 'Sair',
        icon: 'logout',
        iconType: 'material',
        link: '/logout',
        old: false,
      },
    ],
  },
];
